import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { fetchStates } from "../bpSlice";
import { countryIsoCode } from "../../../../../constants/actionTypes";

import { useDispatch } from "react-redux";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      marginBottom: theme.spacing(1),
    },
  },
}));

export default function SelectCountry(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { value, countryCode, handleChange , error } = props;
  const [countryStates, setStates] = useState([])

  useEffect(() => {
    fetchStatesByCountryCode(countryCode);
  }, [countryCode])

  async function fetchStatesByCountryCode(countryCode) {
    if (countryCode > 0) {
      const result = await dispatch(fetchStates(countryCode));
      setStates(result.payload);
    }
  }
  return (
    <div className={classes.root}>
      <TextField
        id="State"
        error={error?.length > 0}
        helperText={error?.length ? error : ""}
        select
        label="State *"
        value={value}
        onChange={handleChange("state")}
        variant="outlined"
        fullWidth
        color="secondary"
      >
        {countryStates.map((option) => (            
          <MenuItem key={option.alphaCode} value={option.alphaCode}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );

  // used for when we allowing states in the future for other countries beside US
  // if (countryCode == '840'){
  //   return (
  //     <div className={classes.root}>
  //       <TextField
  //         id="State"
  //         error={error?.length > 0}
  //         select
  //         label="State"
  //         value={value}
  //         onChange={handleChange("state")}
  //         variant="outlined"
  //         fullWidth
  //         color="secondary"
  //       >
  //         {countryStates.map((option) => (            
  //           <MenuItem key={option.alphaCode} value={option.alphaCode}>
  //             {option.name}
  //           </MenuItem>
  //         ))}
  //       </TextField>
  //     </div>
  //   );
  // }else {
  //   return (
  //     <div className={classes.root}>
  //       <TextField
  //         id="State"
  //         error={error?.length > 0}
  //         label="State"
  //         value={value}
  //         onChange={handleChange("state")}
  //         variant="outlined"
  //         fullWidth
  //         color="secondary"
  //       >
  //       </TextField>
  //     </div>
  //   );
  // }
 


}
